<div class="accordion rounded-pill mt-2" id="accordionPanelsStayOpenExample8">
  <div class=" accordion-item rounded-corner shadow-b">
    <div id="panelsStayOpen-collapseOne8" #scrollChat   
    class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
      <div class="accordion-body text-center  bg-secondary p-2 rounded-corner shadow-b">

          <div class="container-fulied">
            <div class="row m-0" *ngIf="agentLoginStatus">
                <div class=" col-md-6 ">
                  <div class=" font-md m-1 m-0 fw-normal font-primary-color lh-1 text-primary">
                    <div class="col-12 fw-normal">
                        Total Login Time
                    </div>
                  </div>
                    <div class="time-h bg-white rounded-corner line-bar" title="Total Login time"
                    data-bs-toggle="tooltip" data-bs-placement="top">  
                      <svg  xmlns="http://www.w3.org/2000/svg" width="26" viewBox="0 0 512 512" class="svg-clock me-2">
                        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z" ></path>
                      </svg>
                      <span class="badge badge-dark  bg-log text-primary time-color"> {{LoginHours}}</span>
                      <span class="badge badge-dark text-primary w-1 sm-timer ">:</span>
                      <span class="badge badge-dark  bg-log text-primary time-color"> {{LoginMinutes}}</span>
                      <span class="badge badge-dark text-primary w-1 sm-timer ">:</span>
                      <span class="badge badge-dark  bg-log text-primary time-color"> {{LoginSeconds}}</span>
                    </div> 
                </div>
                <div class="col-md-6">
                  <div class=" font-md m-1 m-0 fw-normal font-primary-color lh-1 text-primary">   
                    <div class="col-12 fw-normal">
                        Total Block Time
                    </div>
                  </div>
                    <div class=" time-h bg-white rounded-corner" title="Total Block time"
                    data-bs-toggle="tooltip" data-bs-placement="top" >   
                      
                      <svg  xmlns="http://www.w3.org/2000/svg" width="26" viewBox="0 0 512 512" class="svg-clock me-2">
                        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z" ></path>
                      </svg>
                      <span class="badge badge-dark  bg-log text-primary time-color"> {{BlockHours}}</span>
                      <span class="badge badge-dark text-primary w-1 sm-timer ">:</span>
                      <span class="badge badge-dark bg-block text-primary time-color"> {{BlockMinutes}}</span>
                      <span class="badge badge-dark text-primary w-1 sm-timer ">:</span>
                      <span class="badge badge-dark bg-block text-primary time-color"> {{BlockSeconds}}</span>
                    </div> 
                </div>
            </div>
              
            <div class="row m-0" *ngIf="!agentLoginStatus">
                <div class=" col-md-6 ">
                  <div class=" font-md m-1 m-0 fw-normal font-primary-color lh-1 text-primary">
                    <div class="col-12">
                        Total Login Time
                    </div>
                  </div>
                    <div class="time-h bg-white rounded-corner line-bar">  
                      
                      <svg  xmlns="http://www.w3.org/2000/svg" width="26" viewBox="0 0 512 512" class="svg-clock me-2">
                        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z" ></path>
                      </svg>
                        <span class="badge badge-dark  bg-log text-primary time-color"> 00 </span>
                          <span class="badge badge-dark text-primary w-1 sm-timer ">:</span>
                          <span class="badge badge-dark  bg-log text-primary time-color"> 00 </span>
                        </div> 
                </div>
                <div class="col-md-6">
                  <div class=" font-md m-1 m-0 fw-normal font-primary-color lh-1 text-primary">   
                    <div class="col-12">
                        Total Block Time
                    </div>
                  </div>
                    <div class=" time-h bg-white rounded-corner">   
                      
                      <svg  xmlns="http://www.w3.org/2000/svg" width="26" viewBox="0 0 512 512" class="svg-clock me-2">
                        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z" ></path>
                      </svg>
                          <span class="badge badge-dark bg-block text-primary time-color"> 00 </span>
                          <span class="badge badge-dark text-primary w-1 sm-timer ">:</span>
                          <span class="badge badge-dark bg-block text-primary time-color"> 00 </span>
                         
                        </div> 
                </div>
            </div>
          </div>
    </div>
  </div>
</div>


  
  